import React from 'react';
import { useTranslation } from 'react-i18next';
import { MoreVertical, Pencil, Plus, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import type { VerificationUnit } from '../../../types/verification';

export interface UnitActionsMenuProps {
  unit: VerificationUnit;
  onAddItem?: (unitId: string) => void;
  onEditUnit?: (unit: VerificationUnit) => void;
  onDeleteUnit?: (unitId: string) => void;
}

const UnitActionsMenu: React.FC<UnitActionsMenuProps> = ({
  unit,
  onAddItem,
  onEditUnit,
  onDeleteUnit,
}) => {
  const { t } = useTranslation();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon-sm"
          aria-label={t('common.actions')}
          className="size-6 [&_svg]:size-4"
        >
          <MoreVertical strokeWidth={1.8} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="revy-ui">
        {onAddItem && (
          <DropdownMenuItem onSelect={() => onAddItem(unit.id)}>
            <Plus strokeWidth={1.8} />
            {t('verification.addItem')}
          </DropdownMenuItem>
        )}
        {onEditUnit && (
          <DropdownMenuItem onSelect={() => onEditUnit(unit)}>
            <Pencil strokeWidth={1.8} />
            {t('verification.editUnit')}
          </DropdownMenuItem>
        )}
        {onDeleteUnit && (
          <DropdownMenuItem
            onSelect={() => onDeleteUnit(unit.id)}
            className="text-destructive focus:text-destructive"
          >
            <Trash2 strokeWidth={1.8} />
            {t('verification.deleteUnit')}
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default UnitActionsMenu;
